import type { CreativeFamily } from './creative-api';

/**
 * Flip one version's `archived` flag inside the family and return a NEW family (or the same reference
 * when nothing changed). version_count is recomputed from the surviving non-archived versions so the
 * card's "N versions" badge stays consistent with the editor's Versions / Archived lists. This drives
 * the OPTIMISTIC archive: the editor reads its lists straight off the family, so flipping the flag moves
 * a version into or out of "Archived" instantly, with no wait on the archive round-trip or a refetch.
 */
export const withVersionArchived = (
  family: CreativeFamily | undefined,
  versionId: string,
  archived: boolean,
): CreativeFamily | undefined => {
  if (!family) return family;
  let changed = false;
  const placements = family.placements.map((p) => ({
    ...p,
    items: p.items.map((it) => {
      if (!it.versions?.some((v) => v.id === versionId && Boolean(v.archived) !== archived)) return it;
      changed = true;
      const versions = it.versions.map((v) => (v.id === versionId ? { ...v, archived } : v));
      return { ...it, versions, version_count: versions.filter((v) => !v.archived).length };
    }),
  }));
  return changed ? { ...family, placements } : family;
};
